<template>
  <div
    :class="[
      'organism two-column-grid flex flex-wrap justify-center gap-[6%] px-8 md:px-0',
      randomUniqueClass,
      'container-' + organism.containerWidth,
    ]"
  >
    <div
      v-for="(item, index) in organism.item"
      :key="'item-' + index"
      :id="item.id"
      :class="[
      item.cssClasses,
      'grid-panel w-full md:w-[44%] max-w-[475px] mb-16',
      ]"
    >
      <img
        v-if="item.image"
        :src="getImageSrc(item.image, 'large')"
        alt=""
        :class="organism.rounded"
        class="object-cover w-full h-[250px]"
      />
      <div v-html="item.description" class="text-gray-500 description my-6"></div>
      <MoleculesButtons
        v-if="item.button1"
        :buttons="item"
        :button-colors="[
          item.button1Color ?? 'button-blue',
          item.button2Color ?? 'button-white',
          item.button3Color ?? 'button-white',
        ]"
      />
    </div>
  </div>
</template>

<style>
.two-column-grid {
  .description {
    p {
      @apply text-center text-xl;
    }
  }

  .buttons {
    @apply justify-center;
  }
}
</style>
<script setup>
const props = defineProps({
  organism: Object,
});

// Need to scope the CSS selectors with a unique classname to prevent issues when multiple accordion organisms are present on the page.
const randomUniqueClass = "accordion-" + generateRandomString(8);

onMounted(() => {
  if (props.organism.containerWidth === "full-width") {
    addFullWidthSupport();
  }

  const headersSelector = "." + randomUniqueClass + " .accordion-header button";
  const accordionHeaders = document.querySelectorAll(headersSelector);

  accordionHeaders.forEach((header) => {
    header.addEventListener("click", () => {
      const accordionContentId = header.getAttribute("aria-controls");
      const contentSelector =
        "." + randomUniqueClass + " #" + accordionContentId;
      const accordionContent = document.querySelector(contentSelector);
      const isExpanded = header.getAttribute("aria-expanded") === "true";

      header.setAttribute("aria-expanded", !isExpanded);
      accordionContent.setAttribute("aria-hidden", isExpanded);
    });
  });
});
</script>
